import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import StudioView from "@/views/StudioView.vue";
import VPSView from "@/views/VPSView.vue";
import SolutionView from "@/views/SolutionView.vue";
import ModelView from "@/views/ModelView.vue";
import AboutUsView from "@/views/AboutUsView.vue";
import NewsView from "@/views/NewsView.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import UserAgreement from "@/views/UserAgreement.vue";

// 移动端
import MobileHome from "@/views/mobile/HomeView.vue";
import MobileStudio from "@/views/mobile/StudioView.vue";
import MobileVPS from "@/views/mobile/VPSView.vue";
import MobileSolution from "@/views/mobile/SolutionView.vue";
import MobileSolution2 from "@/views/mobile/SolutionView2.vue";
import MobileAboutUs from "@/views/mobile/AboutUsView.vue";
import MobileCounselling from "@/views/mobile/CounsellingView.vue";
import MobileNews from "@/views/mobile/NewsView.vue";
import MobileModel from "@/views/mobile/ModelView.vue";

let routes: Array<RouteRecordRaw> = [];
const userAgent = navigator.userAgent.toLowerCase();
if (
  !userAgent.match(
    /(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone|windows mobile|windows ce|ucweb|rv:1.2.3.4|midp)/i
  )
) {
  routes = [
    {
      path: "/home",
      name: "home",
      alias: "/",
      component: HomeView,
      meta: {
        hideTitle: true,
      },
    },
    {
      path: "/studio",
      name: "studio",
      component: StudioView,
      meta: {
        hideTitle: true,
      },
    },
    {
      path: "/vps",
      name: "vps",
      component: VPSView,
      meta: {
        hideTitle: true,
      },
    },
    {
      path: "/solution",
      name: "solution",
      component: SolutionView,
      meta: {
        hideTitle: true,
        keepAlive: true,
      },
    },
    {
      path: "/details",
      name: "details",
      component: ModelView,
      meta: {
        hideTitle: true,
      },
    },
    {
      path: "/about-us",
      name: "about-us",
      component: AboutUsView,
      meta: {
        hideTitle: true,
      },
    },
    {
      path: "/about-us-privacy_policy",
      name: "about-us-privacy_policy",
      component: PrivacyPolicy,
    },
    // {
    //   path: "/user-agreement",
    //   name: "user-agreement",
    //   component: UserAgreement,
    // },
    {
      path: "/company-news",
      name: "company-news",
      component: NewsView,
      meta: {
        hideTitle: true,
      },
    },
  ];
} else {
  routes = [
    {
      path: "/home",
      name: "home",
      alias: "/",
      component: MobileHome,
    },
    {
      path: "/studio",
      name: "studio",
      component: MobileStudio,
    },
    {
      path: "/vps",
      name: "vps",
      component: MobileVPS,
    },
    {
      path: "/solution",
      name: "solution",
      component: MobileSolution,
      meta: {
        hideTitle: true,
        keepAlive: true,
      },
    },
    {
      path: "/solution2",
      name: "solution2",
      component: MobileSolution2,
      meta: {
        hideTitle: true,
      },
    },
    {
      path: "/about-us",
      name: "about-us",
      component: MobileAboutUs,
      meta: {
        hideTitle: true,
      },
    },
    {
      path: "/counselling",
      name: "counselling",
      component: MobileCounselling,
      meta: {
        hideTitle: true,
      },
    },
    {
      path: "/news",
      name: "news",
      component: MobileNews,
      meta: {
        hideTitle: true,
      },
    },
    {
      path: "/details",
      name: "details",
      component: MobileModel,
      meta: {
        hideTitle: true,
      },
    },
  ];
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // scrollBehavior 用于控制路由切换时的滚动行为
  // 保存滚动位置，当返回时恢复到之前的位置
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的滚动位置，恢复它（比如浏览器后退）
    if (savedPosition) {
      return savedPosition;
    }
    // 如果是从缓存页面返回，保持滚动位置
    if (from.meta.keepAlive && to.meta.keepAlive) {
      return {};
    }
    // 默认滚动到顶部
    return { top: 0 };
  },
});

export default router;
